/**
 * Created by wuyanbin on 2019/10/28
 */
import React, { Component } from 'react';
import style from '../index.less';
class QuarterArea extends Component {
    constructor() {
        super(...arguments);
        this.handleChangeQuarter = (item) => {
            this.props.handleChangeQuarter(item);
        };
    }
    render() {
        const { quarterList } = this.props;
        return (<div className="ant-calendar-month-panel-body">
        <div className={style.panelContainer}>
          {quarterList.map((item, index) => {
            return (<div className={style.quarterContainer} key={index}>
                  <span onClick={() => {
                this.handleChangeQuarter(item);
            }} className={`'ant-calendar-month-panel-cell' ${item.selected ? 'ant-calendar-month-panel-selected-cell' : ''} ${item.disabled ? 'ant-calendar-month-panel-cell-disabled' : ''}`}>
                    <a className="ant-calendar-month-panel-month">
                      {item.label}
                    </a>
                  </span>
                </div>);
        })}
        </div>
      </div>);
    }
}
export default QuarterArea;
